/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_YouInputs */

const en_settings_tickets_you = /** @type {(inputs: Settings_Tickets_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

const zh_settings_tickets_you = /** @type {(inputs: Settings_Tickets_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我`)
};

/**
* | output |
* | --- |
* | "You" |
*
* @param {Settings_Tickets_YouInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_you = /** @type {((inputs?: Settings_Tickets_YouInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_YouInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_you(inputs)
	return zh_settings_tickets_you(inputs)
});
export { settings_tickets_you as "settings.tickets.you" }